'use client';


/** Imports */
import React from 'react';
import Link from 'next/link';
import styles from './style.module.css';
import ThemeSwitcher from './ThemeSwitcher';
import {APP_VERSION} from '@/modules/utils';
import {MdFavoriteBorder} from 'react-icons/md';
import LanguageSwitcher from './LanguageSwitcher';
import {useLocale, useTranslations} from 'next-intl';
import ExternalLink from '@/components/ExternalLink/ExternalLink';


/** Component */
export default function Footer() {


    // Hooks
    const locale = useLocale();
    const t = useTranslations('common.Navigation.Legals.items');
    const tFooter = useTranslations('common.footer');


    // Render
    return (
        <footer className={styles.footer}>
            <div className={styles.layout}>

                {/* Navigation */}
                <div className={styles.navigation}>
                    <Link href={`/${locale}/help-center`} className={styles.item}>
                        {t('helpCenter')}
                    </Link>
                    <Link href={`/${locale}/legals/legal-notice`} className={styles.item}>
                        {t('legalNotice')}
                    </Link>
                    <Link href={`/${locale}/legals/privacy-policy`} className={styles.item}>
                        {t('privacyPolicy')}
                    </Link>
                    <Link href={`/${locale}/legals/terms-of-service`} className={styles.item}>
                        {t('termsOfService')}
                    </Link>
                    <Link href={`/${locale}/legals/open-source-attributions`} className={styles.item}>
                        {t('openSourceAttributions')}
                    </Link>
                    <Link href={`/${locale}/status`} className={styles.item}>
                        {t('statusPage')}
                    </Link>
                </div>

                {/* Copyright */}
                <div className={styles.copyright}>
                    {tFooter.rich('madeWith', {
                        heart: () => <MdFavoriteBorder/>,
                        company: (children) => (
                            <ExternalLink href={'https://mainsent.com'}>
                                {children}
                            </ExternalLink>
                        ),
                    })}
                    <br/>
                    {tFooter('version', {version: APP_VERSION})}
                </div>

                {/* Theme switcher */}
                <ThemeSwitcher/>

                {/* Language switcher */}
                <LanguageSwitcher/>
            </div>
        </footer>
    );
}
